import { gql } from '@apollo/client'

import { MENU_TITLE_NODE_FRAGMENT } from '../fragments'

const UPDATE_MENU_TITLE_MUTATION = gql`
  mutation updateMenuTitle($id: ID!, $data: MenuTitleUpdateInput!) {
    updateMenuTitle(id: $id, data: $data) {
      ...MenuTitleNodeFragment
    }
  }
  ${MENU_TITLE_NODE_FRAGMENT}
`

export default UPDATE_MENU_TITLE_MUTATION
